exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\ndiv[data-v-2b116639] {\n  color: #333;\n}\nstrong[data-v-2b116639] {\n  margin-bottom: 10px;\n}\np[data-v-2b116639] {\n  margin-bottom: 0;\n}\n", ""]);

// exports
